import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory({
  basename: (window).basename,
});

export default browserHistory;
